export default class AnchorSections {
	constructor(config) {
		this.el = config.el || document.querySelectorAll(".anchorSections");
		this.links = this.el.querySelectorAll(
			".anchor-sections__navigation-link"
		);
		this.sections = this.el.querySelectorAll(".anchor-sections__section");
		this.processBar = this.el.querySelector(
			".anchor-sections__navigation-procces-bar-percentage"
		);
		this.currentClass = "anchor-sections__navigation-link--current";
		this.mobileNav = this.el.querySelector(".anchor-sections__mobile-nav");
		this.offset = 180;
		this.select = this.el.querySelector(".anchor-sections__select");

		this.init();
	}
	init() {
		const self = this;
		this.attachEvents();
		this.setCurrent();
		this.checkHash();
		utilities.setAriaProp(this.links[0].parentElement, "current", true);
	}
	checkHash() {
		const self = this;
		let hash = window.location.hash;
		if (hash) {
			hash = decodeURI(hash);
			const sectionMatch = this.el.querySelector(hash);

			if (sectionMatch) {
				var position = sectionMatch.getBoundingClientRect();
				var top = position.top + window.pageYOffset;
				window.scroll({
					top: top,
					left: 0,
					behavior: "smooth"
				});
			}
		}
	}
	attachEvents() {
		const self = this;
		this.links.forEach(link => {
			link.addEventListener("click", function(event) {
				event.preventDefault();
				self.scrollToSection(link.hash);
			});
		});
		this.select.addEventListener("change", function(event) {
			self.scrollToSection(event.target.value);
		});

		this.mobileNav.addEventListener("keydown", function(event) {
			console.log(event.code);
			if (event.code === "Space") {
				event.preventDefault();
			}
		});
		utilities.emitter.on("window/scroll", function() {
			self.setCurrent();
		});
	}
	scrollToSection(id) {
		const section = this.el.querySelector(id);
		var position = section.getBoundingClientRect();
		var top = position.top + window.pageYOffset - this.offset - 5;
		utilities.setHashUrl(id.substring(1));
		window.scroll({
			top: top,
			left: 0,
			behavior: "smooth"
		});
		section.focus({ preventScroll: true });
	}
	setCurrent() {
		const self = this;
		let scrollTop = window.pageYOffset;
		let hasCurrent = false;
		let sectionPosition = 0;
		let indexOfSection = 0;

		this.links.forEach(link => {
			let section = self.el.querySelector(link.hash);
			var position = section.getBoundingClientRect();
			var top = position.top + window.pageYOffset - self.offset - 15;
			var bottom = top + section.offsetHeight - 13;
			const isInView = top <= scrollTop && bottom > scrollTop;

			if (isInView) {
				hasCurrent = true;
				indexOfSection = Array.from(
					section.parentElement.children
				).indexOf(section);
				sectionPosition = position;

				link.parentElement.classList.add(self.currentClass);
				utilities.setAriaProp(link.parentElement, "current", true);
				self.setProccesBar(sectionPosition, indexOfSection);
			} else {
				link.parentElement.classList.remove(self.currentClass);
				utilities.setAriaProp(link.parentElement, "current", false);
			}
		});
		const elPosition = this.el.getBoundingClientRect();
		const elTop = elPosition.top;
		const elBottom = elPosition.top + this.el.offsetHeight;

		if (!hasCurrent) {
			if (elTop > 190) {
				this.links[0].parentElement.classList.add(self.currentClass);
				utilities.setAriaProp(
					this.links[0].parentElement,
					"current",
					true
				);
				indexOfSection = 0;
			} else if (elBottom < 190) {
				this.links[this.links.length - 1].parentElement.classList.add(
					self.currentClass
				);
				utilities.setAriaProp(
					this.links[this.links.length - 1].parentElement,
					"current",
					true
				);
				indexOfSection = this.sections.length;
			}
		}
	}
	setProccesBar(sectionPosition, index) {
		let sectionPositionWithOffset = sectionPosition.top - this.offset + 5;

		let positionInPercent =
			(sectionPositionWithOffset / sectionPosition.height) * 100;
		let percentageStep = 100 / this.sections.length;
		const sectionScrollInPercent = Math.abs(
			((sectionPosition.top - this.offset) / sectionPosition.height) *
				((100 * percentageStep) / 100)
		);

		let percentage = index * percentageStep + sectionScrollInPercent;
		if (percentage > (this.sections.length - 1) * percentageStep) {
			percentage = (this.sections.length - 1) * percentageStep;
		}
		this.processBar.style.height = percentage + "%";
	}
}
